"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.history = void 0;
var redux_saga_1 = __importDefault(require("redux-saga"));
var redux_1 = require("redux");
var redux_persist_1 = require("redux-persist");
var storage_1 = __importDefault(require("redux-persist/lib/storage"));
var connected_react_router_1 = require("connected-react-router");
var history_1 = require("history");
var redux_logger_1 = require("redux-logger");
var reducer_1 = require("./reducer");
var saga_1 = __importDefault(require("./saga"));
var persistConfig = {
    key: 'root',
    storage: storage_1.default,
    blacklist: ['restaurant', 'product']
};
exports.history = (0, history_1.createBrowserHistory)();
var persistedReducer = (0, redux_persist_1.persistReducer)(persistConfig, (0, reducer_1.rootReducer)(exports.history));
function configureStore(initialState) {
    var sagaMiddleware = (0, redux_saga_1.default)();
    var loggerMiddleware = (0, redux_logger_1.createLogger)({
        predicate: function () { return process.env.NODE_ENV === 'development'; },
    });
    var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;
    var middlewares = [(0, connected_react_router_1.routerMiddleware)(exports.history), loggerMiddleware, sagaMiddleware];
    var store = (0, redux_1.createStore)(persistedReducer, initialState, composeEnhancers(redux_1.applyMiddleware.apply(void 0, middlewares)));
    sagaMiddleware.run(saga_1.default);
    var persistor = (0, redux_persist_1.persistStore)(store);
    return { store: store, persistor: persistor };
}
exports.default = configureStore;
